import * as ko from 'knockout'
import { Params, TrotStarterViewModel } from './TrotStarterViewModel'
import template from './trot.starter.tpl.html'

if (!ko.components.isRegistered('trot-starter')) {
  ko.components.register('trot-starter', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new TrotStarterViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
